export const AUTHORIZED_PAGES = ['for-dig'];
